var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompareSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32,22l-16.5814209-0.0045166l5.2884521-5.2884521l-1.4140625-1.4140625L14,20.5859375 C13.3554688,21.2304688,13,22.0878906,13,23s0.3554688,1.7695312,1,2.4140625l5.2929688,5.2929688l1.4140625-1.4140625 L15.4140625,24c-0.0012817-0.0013428-0.001709-0.0031738-0.0029907-0.0045166L32,24V22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,9c0-0.9121094-0.3554688-1.7695312-1-2.4140625l-5.2929688-5.2929688l-1.4140625,1.4140625L16.5859375,8 c0.0012817,0.0013428,0.001709,0.0031738,0.0029907,0.0045166L0,8v2l16.5814209,0.0045166l-5.2884521,5.2884521 l1.4140625,1.4140625L18,11.4140625C18.6445312,10.7695312,19,9.9121094,19,9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompareSmall);
export default __webpack_public_path__ + "static/media/compare--small.6c679be13b34bd5509447643275fcd83.svg";
export { ForwardRef as ReactComponent };